import { Button, Typography } from '@mui/material';
import Grid from 'components/core/Grid';
import { useListPageModalNavigation } from '../modal/hooks/useListPageModalNavigation';

import { ContentSection, StyledAppCard } from './styles';

export const AlreadyHost = ({ openModal }: { openModal: () => void }) => {
  const { pushAssistedUrl } = useListPageModalNavigation();
  const openAssistedSetUpModal = () => {
    // set the params
    pushAssistedUrl();
    openModal();
  };
  return (
    <ContentSection>
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <StyledAppCard>
            <Typography variant="h3" mb={2}>
              Already Host on Another Website?
            </Typography>
            <Typography>
              Our team is standing by to help you build your listing. <br />
              Have a member of the alluraDirect team begin setting up your vacation rental listing within the next
              business day by providing some information.
            </Typography>
            <Button variant="text" color="secondary" size="large" onClick={openAssistedSetUpModal}>
              Click Here for Quick Start
            </Button>
          </StyledAppCard>
        </Grid>
      </Grid>
    </ContentSection>
  );
};
